'use client';
import style from './categoryDropdown.module.scss';
import React, { useEffect, useRef, useState } from 'react';
import { sleep } from '@/utils/sleepUtils';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25373';
import { useTranslation } from '@/i18n/client';
import CDNImage from '@/components/cdnImage/cdnImage';
import {
  SEARCH_EVENT_NAMES,
  searchBusinessLogger,
} from '@/utils/logger/instance/searchBusinessLogger';

const CategoryDropdown = ({ categoryData }) => {
  const categories = categoryData?.categoryList || [];
  const { t } = useTranslation();
  const rightRef = useRef(null);
  const lv1CateId = useRef('');
  const mouseX = useRef(10000000);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [clickFlag, setClickFlag] = useState(false);
  const [isActive, setIsActive] = useState(categoryData?.isActive || { lv1: '' });

  //点击三级类目
  const handleClickThirdCategory = (
    firstCategory,
    secondcid,
    second_category_name,
    thirdcid,
    third_category_name,
    index,
    brokerInfo,
  ) => {
    sendClickTrack.Category_Main_ThirdCategory({
      firstcid: firstCategory.cateId,
      first_category_name: firstCategory.cateName,
      secondcid: secondcid || '-100',
      second_category_name: second_category_name || '-100',
      thirdcid: thirdcid,
      third_category_name: third_category_name,
      index,
      broker_info: brokerInfo || '-100',
    });
    window.location.href = `/s?k=${encodeURIComponent(third_category_name.trim())}&l1=${firstCategory.cateId}&l2=${secondcid}&l3=${thirdcid}`;
  };

  //右侧三级类目根据currentIndex触发滚动
  useEffect(() => {
    if (!clickFlag) {
      return;
    }
    let scrollHeight = 0;
    for (let i = 0, length = Array.from(rightRef.current?.children || []).length; i < length; i++) {
      if (i < currentIndex) {
        scrollHeight += rightRef.current?.children[i].getBoundingClientRect().height || 0;
      } else {
        break;
      }
    }
    rightRef.current?.scrollTo(0, scrollHeight);
  }, [currentIndex, clickFlag]);

  useEffect(() => {
    if (categories.length > 0) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (clickFlag) {
              return;
            }
            if (entry.isIntersecting) {
              const index = Array.from(entry.target.parentNode.children).findIndex(
                (item) => item === entry.target,
              );
              setCurrentIndex(index);
            }
          });
        },
        {
          root: rightRef.current,
          // 120px为一个类目行的高度
          rootMargin: `0px 0px ${120 - (rightRef.current?.getBoundingClientRect().height || 0)}px 0px`,
        },
      );

      document.querySelectorAll('.observer-hook').forEach((el) => {
        observer.observe(el);
      });

      return () => {
        observer.disconnect();
      };
    }
  }, [categories, clickFlag]);
  //类目图片加载失败
  const onCategoryImageLoadError = (e, firstCategory, thirdCategory) => {
    searchBusinessLogger({
      eventName: SEARCH_EVENT_NAMES.CATEGORY_IMG_ERROE,
      message: {
        firstCategoryId: firstCategory.cateId,
        firstCategoryName: firstCategory.cateName,
        thirdCategoryId: thirdCategory?.cateId,
        thirdCategoryName: thirdCategory?.cateName,
        imageUrl: thirdCategory?.cateImageUri,
      },
    });
  };

  const getChildrenCategory = () => {
    const activeLv1 = categories.find((x) => x.cateId === isActive.lv1);
    if (categories?.length > 0) {
      return (
        <>
          <div className={style['category-divider']}></div>
          <ul
            className={style['category-list-right']}
            ref={rightRef}
            onTouchStart={() => setClickFlag(false)}
          >
            {categories.map((cate, i) => (
              <li
                className={`${style['category-list-lv3-li']} observer-hook`}
                key={cate.id}
                onMouseEnter={(e) => categoryMouseEnter(e, cate, i, true)}
              >
                <div className={style['category-list-lv2-title']}>
                  <span className={style['lv2-title']}>{cate.cateName}</span>
                </div>

                <div className={style['category-list-lv3-items']}>
                  {cate?.childrenList.length > 0
                    ? cate.childrenList.map((lv3, ii) => {
                        return (
                          <div
                            className={style['category-list-lv3-item']}
                            key={lv3.id}
                            onClick={() =>
                              handleClickThirdCategory(
                                activeLv1,
                                lv3.secondCateId,
                                lv3.secondCateName,
                                lv3.cateId,
                                lv3.cateName,
                                ii,
                                lv3.brokerInfo,
                              )
                            }
                            exptag={`exp|${EXPOSURE_RECORD.Category_Main_ThirdCategory_Expo}`}
                            data-exptag-config={JSON.stringify({
                              useClick: false, // 是否用点击接口,默认使用曝光接口   exptag-config-useClick
                              stay_duration: 0.3, // 曝光时长    exptag-config-stay_duration
                              repeated: false, // 是否可重复曝光  exptag-config-repeated
                              area_rate: 0.01, // 漏出比例  exptag-config-area_rate
                            })}
                            data-exptag-json-param={JSON.stringify([
                              {
                                firstcid: cate?.cateId,
                                first_category_name: cate?.cateName,
                                secondcid: lv3.secondCateId || '-100',
                                second_category_name: lv3.secondCateName || '-100',
                                thirdcid: lv3.cateId,
                                third_category_name: lv3.cateName,
                                index: ii,
                                broker_info: lv3.brokerInfo || '-100',
                              },
                            ])}
                          >
                            <div className={style['category-list-lv3-items-img']}>
                              <CDNImage
                                style={{ backgroundColor: lv3?.backgroundColor }}
                                src={lv3.cateImageUri}
                                width={82}
                                height={82}
                                alt={lv3.cateName}
                                onError={(e) => onCategoryImageLoadError(e, cate, lv3)}
                              />
                            </div>
                            <div className={style['category-list-lv3-items-name']}>
                              {lv3.cateName}
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
              </li>
            ))}
          </ul>
        </>
      );
    }
    return;
  };

  const categoryMouseEnter = async (e, category, index, isRight = false) => {
    const { pageX, pageY } = e;
    if (isRight) {
      setClickFlag(false);
      const [lv1] = category.bloodIds;
      lv1CateId.current = lv1;
      if (lv1 === lv1CateId.current) {
        setIsActive({ lv1 });
      }
    } else {
      setClickFlag(true);
      const [lv1] = category.bloodIds;
      lv1CateId.current = lv1;
      const distance = pageX - mouseX.current;
      mouseX.current = pageX;
      //判断鼠标是否往右移动
      if (distance > 0) {
        await sleep(500);
      }
      if (lv1 === lv1CateId.current) {
        setIsActive({ lv1 });
        index !== undefined && setCurrentIndex(index);
      }
    }
  };

  return (
    <div className={`category-list-dropdown-layer ${style['category-list-dropdown-layer']}`}>
      {categories.length === 0 ? (
        <div className={style['loading']}>{t('common.loading')}</div>
      ) : (
        <div className={style['category-list-container']}>
          <ul className={style['category-list-lv1']}>
            {/*没有二级类目的一级类目不显示*/}
            {!!categories.length &&
              categories.map((firstCategory, index) => {
                if (firstCategory.childrenList && !!firstCategory.childrenList.length) {
                  return (
                    <li
                      key={firstCategory.cateId}
                      className={`${style['category-list-item']} ${currentIndex === index ? style.active : ''}`}
                      onMouseEnter={(e) => categoryMouseEnter(e, firstCategory, index)}
                      exptag={`exp|${EXPOSURE_RECORD.Category_Main_FirstCategory_Expo}`}
                      data-exptag-config={JSON.stringify({
                        useClick: false, // 是否用点击接口,默认使用曝光接口   exptag-config-useClick
                        stay_duration: 0.3, // 曝光时长    exptag-config-stay_duration
                        repeated: false, // 是否可重复曝光  exptag-config-repeated
                        area_rate: 0.01, // 漏出比例  exptag-config-area_rate
                      })}
                      data-exptag-json-param={JSON.stringify([
                        {
                          firstcid: firstCategory.cateId,
                          first_category_name: firstCategory.cateName,
                          index: index,
                        },
                      ])}
                    >
                      <span>{firstCategory.cateName}</span>
                    </li>
                  );
                }
                return null;
              })}
          </ul>
          {getChildrenCategory()}
        </div>
      )}
    </div>
  );
};
export default CategoryDropdown;
